import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useTheme } from '../use-theme/index.js';
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);
    useLayoutEffect(() => {
        setMatches(window.matchMedia(query).matches);
    }, [query]);
    useEffect(() => {
        const media = window.matchMedia(query);
        const callback = (event) => setMatches(event.matches);
        media.addEventListener('change', callback);
        return () => {
            media.removeEventListener('change', callback);
        };
    }, [query]);
    return matches;
};
const MQ_PREFIX = '@media ';
export const useMatchViewport = (mediaQuery, bp1, bp2) => {
    const { mediaQueries } = useTheme();
    const normalizedQuery = useMemo(() => {
        const query = mediaQuery === 'between'
            ? mediaQueries[mediaQuery](bp1, bp2)
            : mediaQueries[mediaQuery](bp1);
        if (query.startsWith(MQ_PREFIX)) {
            return query.substring(MQ_PREFIX.length);
        }
        return query;
    }, [mediaQuery, bp1, bp2]);
    return useMediaQuery(normalizedQuery);
};
//# sourceMappingURL=use-match-viewport.js.map